import { render, staticRenderFns } from "./PLTable.vue?vue&type=template&id=f0feb0ba&"
import script from "./PLTable.vue?vue&type=script&lang=js&"
export * from "./PLTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports